import {RESPONSE_CODES} from "../constants/data";
import { functions } from "../firebase";

import axios from 'axios';

const API_VALIDATE_LINKS = import.meta.env.VITE_VALIDATE_LINK_API_PATH;
const API_VALIDATE_QUID = import.meta.env.VITE_VALIDATE_QUID_API_PATH;
const API_OPEN_TABLE = import.meta.env.VITE_OPEN_TABLE_API_PATH;
const API_CONFIRM_ORDER = import.meta.env.VITE_CONFIRM_ORDER_API_PATH;
const API_RESET_ORDER = import.meta.env.VITE_RESET_ORDER_API_PATH;
const API_SWITCH_DITS_TO_USER = import.meta.env.VITE_SWITCH_DITS_TO_USER_API_PATH;
const API_REQUEST_BILL = import.meta.env.VITE_REQUEST_BILL_API_PATH;
const API_CREATE_PAYMENT_TRANSACTION = import.meta.env.VITE_PAYMENT_API_CREATE_TRANSACTION;
const UPGRADE_ANONYMOUS_USER = import.meta.env.VITE_UPGRADE_ANONYMOUS_USER;

const CHANNEL = import.meta.env.VITE_CHANNEL ?? 'web';

const _isSuccessResponse = (data: any) => (data.code === RESPONSE_CODES.success || data.code === RESPONSE_CODES.ok);

const _buildErrorFromResponse = (data: any,) => {
    if (!!data && !!data?.error && !!data?.error?.message) {
        return data.error;
    }
    const errorMessage = data.error ?? 'Generic Error';
    return {
        message: errorMessage
    }
};

const validateAndRetrieveLinks = async (linkAlias: string) => {
    const validateLinksApi = functions.httpsCallable(API_VALIDATE_LINKS);
    const data = {
        'link': linkAlias,
        channel:CHANNEL
    };
    const response = await validateLinksApi(data);
    return response.data
}

const validateQuidAndRetrieveMenus = async (token: string) => {
    const validateQuidApi = functions.httpsCallable(API_VALIDATE_QUID);
    const data = {
        token,
        channel:CHANNEL
    };
    const response = await validateQuidApi(data);
    return response.data;
}

const createDits = async (link: string) => {
    const createDitsApi = functions.httpsCallable(API_OPEN_TABLE);
    const data = {
        link,
        channel:CHANNEL
    };
    const response = await createDitsApi(data);
    return response.data;
}

const switchDitsToUser = async (anonymousUid: string) => {
    const switchDitsToUser = functions.httpsCallable(API_SWITCH_DITS_TO_USER);
    const data = {
        anonymousUid: anonymousUid,
        channel:CHANNEL
    }
    const response = await switchDitsToUser(data);
    return response.data;
}

const confirmSessionOrder = async(restaurantID: string, menuId:string, sessionID: string, paymentMethod: string) => {
    const confirmOrderApi = functions.httpsCallable(API_CONFIRM_ORDER);
    const data = {
        restaurantId: restaurantID,
        sessionId: sessionID,
        menuId,
        paymentMethod: paymentMethod,
        channel:CHANNEL
    }
    try {
        const response = await confirmOrderApi(data);
        return response.data;
    } catch (error) {
        throw error;
    }

}

const resetSessionOrder = async(restaurantID: string, menuId:string, sessionID: string, paymentMethod: string): Promise<any> => {
    const resetOrderApi = functions.httpsCallable(API_RESET_ORDER);
    const data = {
        restaurantId: restaurantID,
        sessionId: sessionID,
        menuId,
        paymentMethod: paymentMethod,
        channel:CHANNEL
    }
    try {
        const response = await resetOrderApi(data);
        console.log('@@@@resetOrder response');
        console.log(response);
        if (!!response && !!response.data) {
            return response.data;
        }
        return {};
    } catch (error) {
        return error;
    }

}

const requestBill = async(restaurantId: string, sessionId: string, type: string, askBillForTable: boolean = true) => {
    const requestBillApi = functions.httpsCallable(API_REQUEST_BILL);
    const data = {
        restaurantId,
        sessionId,
        type,
        askBillForTable,
        //paymentMethod: "cash",
        //channel:CHANNEL
    };
    try {
        const response = await requestBillApi(data);
        if (!!response && !!response.data) {
            if (_isSuccessResponse(response.data)) {
                console.log('@@@@@@@response from requestBill');
                console.log(response);
                return response.data;
            }
            throw _buildErrorFromResponse(response.data);
        }
    } catch (error) {
        throw error;
    }
}

interface CreatePaymentTransactionParams {
    restaurantID: string,
    billIDs: string[], 
    tips?: number, 
    cardId?: string|null,
    //type: string,
    wallet: boolean
}

const createPaymentTransaction = async({restaurantID, billIDs, tips, cardId, wallet}: CreatePaymentTransactionParams) => {
    const callable = functions.httpsCallable(API_CREATE_PAYMENT_TRANSACTION);
    const data = {
        restaurantId: restaurantID,
        billsId: billIDs,
        cardId: cardId,
        channel:CHANNEL, 
        tips: tips,
        //type: type,
        wallet: wallet
    }
    const response = await callable(data);
    return response.data;
}

const upgradeAnonymousUser = async () => {
    const upgradeAnonymousUserApi = functions.httpsCallable(UPGRADE_ANONYMOUS_USER);
    const response = await upgradeAnonymousUserApi();
    return response.data;
}

export {
    createDits,
    confirmSessionOrder,
    resetSessionOrder,
    validateAndRetrieveLinks,
    switchDitsToUser,
    requestBill,
    validateQuidAndRetrieveMenus,
    createPaymentTransaction,
    upgradeAnonymousUser,
}
